<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        Match
                    </v-col>
                    <v-col cols="12">
                        <match-filters @setFilters="setFilters"/>
                    </v-col>
                    <v-col cols="12" align="end">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="downloadMatchesCSV">
                            <v-icon dark>mdi-download</v-icon>Export CSV
                        </v-btn>
                        <v-btn class="my-2 mr-2" dark small color="black" @click="showImportDialog = true">
                            <v-icon dark>mdi-upload</v-icon>Upload CSV
                        </v-btn>
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createMatch">
                            <v-icon dark>mdi-plus</v-icon>Create
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <import-dialog
            :open-dialog="showImportDialog"
            entity-label="Matches CSV"
            :successfull-import="successfullImport"
            :message="message"
            file-type=".csv,text/csv"
            @file-import="uploadMatches"
            @close-import-dialog="closeImportDialog"
        />
        <array-view
            :items="matches"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortingChange="sortingChange"
            :type="'match'"
        />
    </v-container>
</template>

<script>
    import matchService from '@/services/match'
    import ArrayView from '@/components/ArrayView'
    import MatchFilters from '@/components/MatchFilters'
    import ImportDialog from '@/components/ImportDialog'

    export default {
        name: 'Match',
        components: { ArrayView, MatchFilters, ImportDialog },
        data: () => {
            return {
                successfullImport: null,
                showImportDialog: false,
                matches: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Team 1',
                        value: 'team1',
                        subLevel: 'name'
                    },
                    {
                        text: 'Team 2',
                        value: 'team2',
                        subLevel: 'name'
                    },
                    {
                        text: 'Score Team 1',
                        value: 'scoreTeam1'
                    },
                    {
                        text: 'Score Team 2',
                        value: 'scoreTeam2'
                    },
                    {
                        text: 'Season',
                        value: 'season',
                        subLevel: 'name'
                    },
                    {
                        text: 'Date',
                        value: 'matchDatetime'
                    },
                    {
                        text: 'Phase',
                        value: 'phase'
                    },
                    {
                        text: 'Type',
                        value: 'season',
                        subLevel: 'type'
                    },
                    {
                        text: 'Cup',
                        value: 'isCup'
                    },
                    {
                        text: 'League',
                        value: 'league'
                    },
                    {
                        text: 'Matchday',
                        value: 'round'
                    },
                    {
                        text: 'Published On Social Media',
                        value: 'publishedOnSocial'
                    }
                ],
                size: 100,
                totalPages: 0,
                page: 1,
                filters: null,
                loading: false,
                message: null,
                sortingOptions: {
                    sortBy: null,
                    sortDesc: null
                }
            }
        },
        watch: {
            filters: {
                handler() {
                    this.fetchFilteredMatches()
                }
            }
        },
        created() {
            this.filters = this.$store.getters.getMatchFilters
            this.page = this.$store.getters.getPage
            this.fetchFilteredMatches()
        },
        methods: {
            sortingChange(options) {
                this.sortingOptions.sortBy = options.sortBy[0]
                this.sortingOptions.sortDesc = options.sortDesc[0] ? 'DESC' : 'ASC'
                this.fetchFilteredMatches()
            },
            downloadMatchesCSV() {
                matchService.downloadMatchesCSV(this.filters).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'matches.csv')
                    document.body.appendChild(link)
                    link.click()
                })
            },
            closeImportDialog() {
                this.showImportDialog = false
                // reset state so dialog shows proper buttons next time
                this.successfullImport = null
            },
            uploadMatches(file) {
                this.successfullImport = null
                const formData = new FormData()
                formData.append('file', file)
                matchService.uploadMatchesCSV(formData).then(() => {
                    this.successfullImport = true
                    this.fetchFilteredMatches()
                    this.closeImportDialog()
                }).catch((error) => {
                    this.successfullImport = false
                    this.message = error.response.data.message || 'Import failed'
                })
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchFilteredMatches()
            },
            handleClick(action, item) {
                if (action === 'togglePublishedOnSocial') {
                    matchService.togglePublishedOnSocial(item.id, item.publishedOnSocial).then(() => {
                        this.fetchFilteredMatches()
                    }).catch((error) => {
                        // revert switch state on error
                        item.publishedOnSocial = !item.publishedOnSocial
                        this.message = error.response.data.message || 'Something failed'
                    })
                    return
                }
                this.$router.push(`/matches/${item.id}/${action}`)
            },
            onDelete(item, page) {
                matchService.deleteMatch(item.id).then(() => {
                    this.page = page
                    this.fetchFilteredMatches()
                })
            },
            setFilters(filters) {
                this.filters = filters
                this.$store.dispatch('setMatchFilters', this.filters)
            },
            createMatch() {
                this.$router.push(`/matches/create`)
            },
            fetchFilteredMatches() {
                this.loading = true
                matchService.getFilteredMatches(this.filters, this.page, this.size, this.sortingOptions).then(resp => {
                    this.matches = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 200px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.promo-category-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
